"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountMaxDay = void 0;
const types_1 = require("../types");
const getCountMaxDay = (months) => {
    if (months.indexOf(types_1.MONTH_OF_YEAR.february) !== -1) {
        return 28;
    }
    if (months.indexOf(types_1.MONTH_OF_YEAR.april) !== -1 ||
        months.indexOf(types_1.MONTH_OF_YEAR.june) !== -1 ||
        months.indexOf(types_1.MONTH_OF_YEAR.september) !== -1 ||
        months.indexOf(types_1.MONTH_OF_YEAR.november) !== -1) {
        return 30;
    }
    return 31;
};
exports.getCountMaxDay = getCountMaxDay;
//# sourceMappingURL=getCountMaxDay.js.map